import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Target, Brain, TrendingUp } from "lucide-react";

export default function DifferenceSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-headline text-slate-900 mb-6">
            The WeSonder Difference: <span className="text-blue-500">Objective Insights</span>, Real Progress
          </h2>
          
          <p className="body-text text-slate-600 max-w-4xl mx-auto">
            Traditional personality assessments suffer from the "get what you give" problem—your results are only as honest as your self-reporting. WeSonder's AI analyzes your actual communication patterns, revealing insights you might not even be aware of.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <Card className="border-slate-200 hover:shadow-lg transition-shadow duration-300">
            <CardContent className="p-6 text-center">
              <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Target className="w-7 h-7 text-red-600" />
              </div>
              <h3 className="feature-title text-slate-900 mb-3">Traditional Assessments</h3>
              <p className="text-slate-600">Based on self-reporting, prone to bias and social desirability</p>
            </CardContent>
          </Card>
          
          <Card className="border-slate-200 hover:shadow-lg transition-shadow duration-300">
            <CardContent className="p-6 text-center">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Brain className="w-7 h-7 text-blue-600" />
              </div>
              <h3 className="feature-title text-slate-900 mb-3">WeSonder AI</h3>
              <p className="text-slate-600">Analyzes actual behavior patterns from your unfiltered messages</p>
            </CardContent>
          </Card>
          
          <Card className="border-slate-200 hover:shadow-lg transition-shadow duration-300">
            <CardContent className="p-6 text-center">
              <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-7 h-7 text-green-600" />
              </div>
              <h3 className="feature-title text-slate-900 mb-3">Actionable Insights</h3>
              <p className="text-slate-600">Specific recommendations based on your actual communication style</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
} 